import React, {Component} from 'react';

import Scatter from './Scatter.js';

const axiasName = {
	"new":"신규",
	"renew":"재계약",
	"total": "클래스",
	"rate": "점유율",
	"derivative_tomobooks":"토모동화",
	"derivative_playkit":"플레이키트",
	"derivative_kidsfarm":"키즈팜",
	"derivative_experience":"체험관"
}

export default class BCGScatter extends Component {


    constructor(props) {
        super(props);
        const x = "total";
        const y = "rate";


        var nurseryList = this.makeRandomData(this.props.nurseryList);
        this.state = {
            chatData : this.getChartData(nurseryList, x, y),
            nurseryList : nurseryList,
            x : x,
            y : y,
            xName : axiasName[x],
            yName : axiasName[y],
        }
    }


    componentWillReceiveProps = (nextProps) => {
    	var nurseryList = this.makeRandomData(nextProps.nurseryList);

        this.setState({
            chartData : this.getChartData(nurseryList, this.state.x, this.state.y),
            nurseryList : nurseryList
        })
    }

    onChangeScatterHandle = (e) => {
    	const target = e.target;
    	const value = target.value;
        const name = target.name;
        
        const opp = name == 'x' ? 'y' : 'x';
        if(this.state[opp] === value) {
        	alert("x와 y를 같은 것으로 설정할 수 없습니다.");
        } else {
        	var title = name+"Name";
        	
        	var stateData = {
	            [name] : value,
	            [title] : axiasName[value]
	        }
	        if(opp === "x") {
	        	stateData.chartData = this.getChartData(this.state.nurseryList, this.state.x, value );
	        } else {
	        	stateData.chartData = this.getChartData(this.state.nurseryList, value, this.state.y );
	        }
	        
	        this.setState(stateData);
        }

    } 

    makeRandomData = (nurseryList) => {
    	if(nurseryList) {
    		var list = [];

    		var _new = 0;
    		var _renew = 0;
    		var _rate = 0;
    		var _total = 0;
    		var _total_growth = 0;
    		var _derivative_tomobooks = 0;
    		var _derivative_playkit = 0;
    		var _derivative_kidsfarm = 0;
    		var _derivative_experience = 0;

    		nurseryList.forEach(branch => {

				branch.data.derivative_tomobooks = branch.data.derivative * 0.5;
				branch.data.derivative_playkit = branch.data.derivative * 0.25;
				branch.data.derivative_kidsfarm = branch.data.derivative * 0.2;
				branch.data.derivative_experience = branch.data.derivative * 0.05;

    			if(_new < branch.data.new) _new = branch.data.new;
    			if(_renew < branch.data.renew) _renew = branch.data.renew;
    			if(_total < branch.data.total) _total = branch.data.total;
    			if(_rate < branch.data.rate) _rate = branch.data.rate;
    			
    			if(_derivative_tomobooks < branch.data.derivative * 0.5) _derivative_tomobooks = branch.data.derivative * 0.5;
    			if(_derivative_playkit < branch.data.derivative * 0.25) _derivative_playkit = branch.data.derivative * 0.25;
    			if(_derivative_kidsfarm < branch.data.derivative * 0.2) _derivative_kidsfarm = branch.data.derivative * 0.2;
    			if(_derivative_experience < branch.data.derivative * 0.05) _derivative_experience = branch.data.derivative * 0.05;
    			/*
	   			_renew += branch.data.renew;
    			_total += branch.data.total;
    			_rate += branch.data.rate;
    			
    			_derivative_tomobooks += branch.data.derivative * 0.5;
    			_derivative_playkit += branch.data.derivative * 0.25;
    			_derivative_kidsfarm += branch.data.derivative * 0.2;
    			_derivative_experience += branch.data.derivative * 0.05;
    			*/
    		});

    		/*
    		_new = _new / nurseryList.length;
    		_renew = _renew / nurseryList.length;
    		_total = _total / nurseryList.length;
    		_rate = _rate / nurseryList.length;
    		_derivative_tomobooks = _derivative_tomobooks / nurseryList.length;
    		_derivative_playkit = _derivative_playkit / nurseryList.length;
    		_derivative_kidsfarm = _derivative_kidsfarm / nurseryList.length;
    		_derivative_experience = _derivative_experience / nurseryList.length;
			*/
    		nurseryList.forEach(branch => {
    			/*
    			branch.bcgMap = {
    				new :  branch.data.new,
    				renew : branch.data.renew,
    				total : branch.data.total,
    				rate : branch.data.rate,
    				total_growth : branch.data.total_growth,
    				derivative_tomobooks : branch.data.derivative * 0.5 ,
    				derivative_playkit : branch.data.derivative * 0.25,
    				derivative_kidsfarm : branch.data.derivative * 0.2,
    				derivative_experience : branch.data.derivative * 0.05
    			}
				*/
    			/*
    			branch.bcgMap = {
    				new :  ((branch.data.new - _new) / _new ) * 100,
    				renew : ((branch.data.renew - _renew) / _renew ) * 100,
    				total : ((branch.data.total - _total) / _total ) * 100,
    				rate : ((branch.data.rate - _rate) / _rate ) * 100,
    				derivative_tomobooks : ((branch.data.derivative * 0.5 - _derivative_tomobooks) / _derivative_tomobooks ) * 100,
    				derivative_playkit : ((branch.data.derivative * 0.25 - _derivative_playkit) / _derivative_playkit ) * 100,
    				derivative_kidsfarm :  ((branch.data.derivative * 0.2 - _derivative_kidsfarm) / _derivative_kidsfarm ) * 100,
    				derivative_experience : ((branch.data.derivative * 0.05 - _derivative_experience) / _derivative_experience ) * 100
    			}
    			*/

    			branch.bcgMap = {
    				new :  (((branch.data.new) / _new ) * 200) - 100,
    				renew : (((branch.data.renew) / _renew ) * 200) - 100,
    				total : (((branch.data.total) / _total ) * 200) - 100,
    				rate : (((branch.data.rate) / _rate ) * 200) - 100,
    				derivative_tomobooks : (((branch.data.derivative * 0.5) / _derivative_tomobooks ) * 200) - 100,
    				derivative_playkit : (((branch.data.derivative * 0.25) / _derivative_playkit ) * 200) - 100,
    				derivative_kidsfarm :  (((branch.data.derivative * 0.2) / _derivative_kidsfarm ) * 200) - 100,
    				derivative_experience : (((branch.data.derivative * 0.05) / _derivative_experience ) * 200) - 100
    			}
    			
    			list.push(branch);

    		});
    		return list;
    	} else {
    		return null;
    	}
    }

    getChartData = (nurseryList, xKey, yKey) => {
    	
    	if(nurseryList) {
    		var A_group = [];
	    	var B_group = [];
	    	var C_group = [];
	    	var D_group = [];
	    	
	    	nurseryList.forEach(branch => {
	    		var x = branch.bcgMap[xKey];
	    		var y = branch.bcgMap[yKey];
	    		
	    		if(x >= 0) {
	    			if(y >= 0) {
	    				A_group.push([x, y, branch.name, branch.data[xKey], branch.data[yKey]]);
	    			} else {
	    				B_group.push([x, y, branch.name, branch.data[xKey], branch.data[yKey]]);
	    			}
	    		} else {
	    			if(y >= 0) {
	    				C_group.push([x, y, branch.name, branch.data[xKey], branch.data[yKey]]);
	    			} else {
	    				D_group.push([x, y, branch.name, branch.data[xKey], branch.data[yKey]]);
	    			}
	    		}
	    	});

	    	
	    	return {
	    		A : A_group,
	    		B : B_group,
	    		C : C_group,
	    		D : D_group
	    	}
    	} else {
    		return null;
    	}
    	
    }


	render() {
		


	        if (this.state.chartData == null) {
	            return (
	                <div className="card border-top border-3 border-top-primary">
	                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
	                        <h5 className="card-header-title">BCG 분포도</h5>
	                    </div>
	                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"50px"}}>
	                        <span className="dashboard-spinner spinner-xxl"></span>
	                    </div>
	                </div>
	            )
	        } else if(this.state.nurseryList.length == 0) {
	            return (
	                <div className="card border-top border-3 border-top-primary">
	                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
	                        <h5 className="card-header-title">BCG 분포도</h5>
	                    </div>
	                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"50px"}}>
	                        No Data
	                    </div>
	                </div>
	            )
	        } else {
	    		return(
	    			<div className="card border-top border-3 border-top-primary">
	                    <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
	                        <h5 className="card-header-title">BCG 분포도</h5>
	                    </div>
	                    <div className="card-body" style={{height:this.props.height + "px"}}>
	                    	<div className="row pb-0" style={{marginTop:"-15px"}}>
								<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
									<select name="x" className="form-control font-10" style={{height : "26px"}} value={this.state.x} onChange={this.onChangeScatterHandle}>
		                                <option value="new">신규</option>
		                                <option value="renew">재계약</option>
		                                <option value="total">클래스</option>
		                                <option value="rate">점유율</option>
		                                <optgroup label="파생상품">
		                                	<option value="derivative_tomobooks">토모동화</option>
			                                <option value="derivative_playkit">플레이키트</option>
			                                <option value="derivative_kidsfarm">키즈팜</option>
			                                <option value="derivative_experience">체험관</option>
		                                </optgroup>
		                            </select>
								</div>
								<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
									<select name="y" className="form-control font-10" style={{height : "26px"}} value={this.state.y}  onChange={this.onChangeScatterHandle} >
		                                <option value="new">신규</option>
		                                <option value="renew">재계약</option>
		                                <option value="total">클래스</option>
		                                <option value="rate">점유율</option>
		                                <optgroup label="파생상품">
		                                	<option value="derivative_tomobooks">토모동화</option>
			                                <option value="derivative_playkit">플레이키트</option>
			                                <option value="derivative_kidsfarm">키즈팜</option>
			                                <option value="derivative_experience">체험관</option>
		                                </optgroup>
		                            </select>
								</div>
	                    	</div>
	                        <Scatter data={this.state.chartData} x={this.state.xName} y={this.state.yName}/>
	                    </div>
	                </div>
	    		)
	        }
		
	}
	
}